import React from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FilterLabel from './common/FilterLabel';

const Container = styled.div`
  border-top: 1px solid var(--text-primary);

  body.theme-platinum & { border-color: var(--primary-b-hr); }
`;

const Button = styled.span`
  cursor: pointer;
  display: block;
  font-size: 1rem;
  line-height: 2;
  position: relative;
  width: 100%;
`;

const AllLabel = styled.span`
  font-weight: 700;
  margin-right: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  body.theme-platinum & { font-weight: 400; }
`;

const Arrow = styled.i`
  position: absolute;
  right: 0;
  top: 0.5em;
`;

class ChoicesFilter extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onExpandedToggle = this.onExpandedToggle.bind(this);

    this.baseId = uniqid();
    this.state = {
      expanded: false,
    };

  }

  shouldComponentUpdate(nextProps, prevState) {
    return this.props.selection.join(',') !== nextProps.selection.join(',')
        || this.props.filters.join(',') !== nextProps.filters.join(',')
        || this.state.expanded !== prevState.expanded;
  }

  onChange(e) {
    const v = e.target.value;

    this.props.onChange(v);
  }

  onExpandedToggle() {
    this.setState(prevState => ({expanded: !prevState.expanded}));
  }

  render() {
    if (this.props.filters.length < 1) {
      return '';
    }

    return (
        <Container className="container py-3">
          {this.renderLabel()}
          {this.renderOptions()}
        </Container>
    );
  }

  renderLabel() {
    if (this.props.collapsible) {
      return (
          <Button className={(this.state.expanded ? 'mb-3' : '')} width="100%" onClick={this.onExpandedToggle}>
            <FilterLabel className="mr-2">{this.props.label}:</FilterLabel>
            <AllLabel>{this.getSelectionLabel()}</AllLabel>
            <Arrow className={'fal mt-1 ml-auto ' + (this.state.expanded ? 'fa-angle-up' : 'fa-angle-down')}></Arrow>
          </Button>
      )
    }

    return <FilterLabel className="mb-3">{this.props.label}</FilterLabel>;
  }

  getSelectionLabel() {
    const result = [];
    const {filters, selection, attributes, partialSet} = this.props;
    const allSelected = selection.length === 0 || (partialSet !== true && selection.length === filters.length);

    filters.forEach(format => (selection.indexOf(format) > -1) && result.push(attributes[format].display_name));

    if (this.props.allLabelFn) {
      return this.props.allLabelFn(result, allSelected);
    }

    if (allSelected) {
      return this.props.allLabel || 'Todos';
    } else {
      return result.join(', ');
    }
  }

  renderOptions() {
    if (this.props.collapsible && !this.state.expanded) {
      return '';
    }

    const {baseId, props} = this;
    const {filters, selection} = props;
    const type = props.multiple !== false ? 'checkbox' : 'radio';

    return (
        <div className="radio-check-cols fade-in">
          {props.all !== false && (
              <div className="custom-control custom-checkbox custom-control-inline mr-3 mb-2">
                <input className="custom-control-input" type={type} value="*" id={baseId + '-all'}
                       onChange={this.onChange}
                       checked={selection.length === 0}
                />
                <label className="custom-control-label" htmlFor={baseId + '-all'}>Todos</label>
              </div>
          )}
          {filters.map(filter => {
            const id = baseId + filter;
            if (!(filter in props.attributes)) return '';
            
            return (
                <div className="custom-control custom-checkbox custom-control-inline mr-3 mb-2" key={filter}>
                  <input className="custom-control-input" type={type} value={filter} id={id}
                         onChange={this.onChange}
                         checked={selection.indexOf(filter) > -1}
                  />
                  <label className="custom-control-label" htmlFor={id}>{props.attributes[filter].display_name}</label>
                </div>
            );
          })}
        </div>
    );
  }

}

ChoicesFilter.propTypes = {
  all: PropTypes.bool,
  allLabel: PropTypes.string,
  allLabelFn: PropTypes.func,
  attributes: PropTypes.object.isRequired,
  collapsible: PropTypes.bool,
  filters: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  partialSet: PropTypes.bool,
  selection: PropTypes.array.isRequired,
};

export default ChoicesFilter;